import z from 'zod'

export const FUEL_LIST_WITH_VOLUME = [
	'gasoline',
	'E10',
	'E5',
	'natural gas',
	'ethane',
	'butane',
	'CNG',
	'diesel',
	'LNG',
	'LPG',
	'petroleum gas', // fallback for other petroleum gases
	'propane',
	'wood',
	'naphtha',
] as const
export const fuelWithVolumeEnum = z.enum(FUEL_LIST_WITH_VOLUME)

export const FUEL_LIST = [
	...FUEL_LIST_WITH_VOLUME,
	'coal',
	'coking coal',
	'petroleum coke',
	// 'unknown',
] as const
export type Fuel = (typeof FUEL_LIST)[number]
export const fuelEnum = z.enum(FUEL_LIST)
